import { useEffect, useRef } from 'react';

interface Props {
  trigger?: () => void;
}

function InfinityScrollTrigger({ trigger }:Props) {
    const ref = useRef<HTMLDivElement>(null);
    useEffect(() => {
        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.intersectionRatio > 0) {
                    trigger?.();
                }
            });
        });
        if (ref.current) {
            observer.observe(ref.current);
            return () => {
                observer.disconnect();
            };
        }
        return () => {};
    }, [ref.current, trigger]);
    return (
        <div style={{ width: '100%', height: 1, marginTop: -1 }}
            ref={ref}/>
    );
}

export default InfinityScrollTrigger;
